import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

export interface Address {
	line1: string;
	line2?: string;
	city: string;
	region: string;
	postal_code: string;
	country: string;
}

@Injectable({
	providedIn: 'root'
})
export class AddressDetailsFormService {
	public changes: Observable<Partial<Address>>;

	private addressForm = new FormGroup({
		line1: new FormControl('', [Validators.required]),
		line2: new FormControl('', [Validators.maxLength(100)]),
		city: new FormControl('', [Validators.required, Validators.maxLength(50)]),
		region: new FormControl('', [Validators.required]),
		postal_code: new FormControl('', [Validators.required, Validators.maxLength(11)]),
		country: new FormControl('US')
	});

	public constructor () {
		this.changes = this.addressForm.valueChanges;
	}

	public getForm (): FormGroup {
		return this.addressForm;
	}

	public getControl (controlName: string): FormControl {
		return this.addressForm.get(controlName) as FormControl;
	}

	public getFieldError (fieldName: string, errorType: string): boolean {
		const field = this.addressForm.get(fieldName);
		return !!(field && (field.dirty || field.touched) && field.hasError(errorType));
	}

	public updateField (fieldName: string, value: any): void {
		const field = this.addressForm.get(fieldName);
		if (field) {
			field.setValue(value);
		}
	}

	public isValid (): boolean {
		return this.addressForm.valid;
	}

	public reset (): void {
		this.addressForm.reset();
	}

	public validateForm (): void {
		this.addressForm.markAllAsTouched();
	}
}
